import { create } from "zustand";
import type { AnimVariant } from "../lib/mapSoilAnimation";

/*
 *
 * **AND IT MUST NOT PLAY TWICE.
 */
interface MapIntroState {
  armedFor: string | null;
  /*
   *
   * Stored WITH the field id, not read from the editor session: the grid school opens the same
   * point editor High-Res does, so the editor being open cannot tell the two stories apart.
   */
  variant: AnimVariant;
  arm: (fieldId: string, variant?: AnimVariant) => void;
  disarm: () => void;
}

export const useMapIntro = create<MapIntroState>((set) => ({
  armedFor: null,
  variant: "sample",
  arm: (fieldId, variant = "sample") => set({ armedFor: fieldId, variant }),
  disarm: () => set({ armedFor: null }),
}));

/*
 *
 * Same discipline as above: armed for a FIELD ID, never a bare boolean.
 */
export const useRxIntro = create<MapIntroState>((set) => ({
  armedFor: null,
  variant: "sample", // unused by the Rx intro; carried so the two stores share one shape
  arm: (fieldId, variant = "sample") => set({ armedFor: fieldId, variant }),
  disarm: () => set({ armedFor: null }),
}));
